<template>
  <section class="experiences">
    <section class="page-section">
      <div class="container">
        <div class="product-item">
          <div class="product-item-title d-flex">
            <div class="bg-faded p-responsive d-flex ml-auto rounded">
              <h2 class="section-heading mb-0">
                <span class="section-heading-upper">Let's talk about my</span>
                <span class="section-heading-lower">Job experiences</span>
              </h2>
            </div>
          </div>
          <img
            class="product-item-img mx-auto d-flex rounded img-responsive mb-3 mb-lg-0"
            src="@/assets/img/pizzaz.png"
            alt=""
          />
          <div class="product-item-description d-flex mr-auto">
            <div class="bg-faded p-responsive rounded">
              <p>
                I've been working as a secretary at the polling station in each
                referendum or election there has been since I got 18 years old.
                Once I turned 13, I started tutoring students in any scientific
                subject. During my university career, I turned this job official
                by working for the S.I.A. association, which made me tutor
                foreign students or people with mental disabilities. Between
                2013 and 2016, I also worked at the Chili Pepper pizza shop as a
                pizza delivery boy.
              </p>
              <p class="mb-0">
                Between 2013 and 2016 I worked for Gedis S.p.a. as a Tournament
                Organizer and Judge of Trading Card Games and videogames events
                of the Pokémon saga. Occasionally, I work for European Union
                Youth associations such as Assonur for small jobs such as
                English/Italian translations or project design.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="page-section">
      <div class="container">
        <div class="product-item">
          <div class="product-item-title d-flex">
            <div class="bg-faded p-responsive d-flex mr-auto rounded">
              <h2 class="section-heading mb-0">
                <span class="section-heading-upper">Let's talk about my</span>
                <span class="section-heading-lower">Overseas experiences</span>
              </h2>
            </div>
          </div>
          <img
            class="product-item-img mx-auto d-flex rounded img-responsive mb-3 mb-lg-0"
            src="@/assets/img/products-02.jpg"
            alt=""
          />
          <div class="product-item-description d-flex ml-auto">
            <div class="bg-faded p-responsive rounded">
              <p>
                I had the chance to travel a lot, and many of my travels turned
                out to be an adventure that shaped my soul in some way. One
                time, for example, I risked getting stuck in Albania because
                there had been problems with the ship I had to get in to get
                back home, and nobody could speak English to notify me of such
                problem. Another time I got stuck in Lion on my way to
                Manchester for a couple of days because of some airport
                bureaucracy.
              </p>
              <p class="mb-0">
                Of course, I could not talk about my travel experiences without
                mentioning my Erasmus+ experiences I had thanks to the Assonur
                association. I had the chance to work with people from all
                around Europe (and bonded with many of them). Thanks to such, I
                had the chance to know some of the cultures coming from Romania,
                Hungary, Albania, Estonia, Serbia, and a part of Switzerland.
                Outside of the Erasmus experiences I also traveled to Britain,
                France, and Spain for entertainment purposes. I wish to travel
                and have many new experiences, trying to understand and live the
                life of the communities all around the world and make them part
                of me.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="page-section">
      <div class="container">
        <div class="product-item">
          <div class="product-item-title d-flex">
            <div class="bg-faded p-responsive d-flex ml-auto rounded">
              <h2 class="section-heading mb-0">
                <span class="section-heading-upper">Let's talk about my</span>
                <span class="section-heading-lower">Other experiences</span>
              </h2>
            </div>
          </div>
          <img
            class="product-item-img mx-auto d-flex rounded img-responsive mb-3 mb-lg-0"
            src="@/assets/img/mountain.jpg"
            alt=""
          />
          <div class="product-item-description d-flex mr-auto">
            <div class="bg-faded p-responsive rounded">
              <p class="mb-0">
                In July 2020 I finished my first IT programming course "Junior
                Full Stack Developer" by The Net Value. The course gave me a new
                perspective and made me decide to grow as a developer, and maybe
                specialize in some programming fields, once I get more
                accustomed to some of them. Each year I participate in the
                Cagliari Global Game Jam, working for 48 hours straight to
                complete a project with a team created on the spot. I would
                recommend such experience to anyone, even to someone not
                interested in programming. In may 2021 I finished an internship,
                where sadly I didn't get the opportunity to learn much about
                programming while working, but I followed some Udemy courses in
                the meantime. I am open and eager to live new experiences,
                hoping the future will give me the chance to find more.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  data: function () {
    return {
      number: 2,
    };
  },
};
</script>

<style lang="scss" scoped>
.product-item {
  @media (min-width: 992px) {
    .product-item-title {
      position: relative;
      z-index: 1;
      margin-bottom: -3rem;
    }
    .product-item-img {
      position: relative;
      z-index: 0;
      max-width: 60vw;
    }
    .product-item-description {
      position: relative;
      z-index: 1;
      margin-top: -3rem;
      max-width: 50vw;
    }
  }
}

.p-responsive {
  //p-2
  padding: 0.5rem;
}

.section-heading-lower {
  font-size: 2rem;
}

@media (min-width: 768px) {
  .p-responsive {
    //p-5
    padding: 1.5rem;
  }
  .section-heading-lower {
    font-size: 3rem;
  }
}
</style>
